import { render, staticRenderFns } from "./CustomerGrouped.vue?vue&type=template&id=769f5383&"
import script from "./CustomerGrouped.vue?vue&type=script&lang=js&"
export * from "./CustomerGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports